import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in German. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardDe: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Guten Tag, {name}",
  "dashboard.subtitle": "{date} · Conakry",
  "dashboard.generatedAt": "Zahlen gelesen um {time} (bis zu einer Minute Verzögerung).",
  "dashboard.refresh": "Aktualisieren",
  "dashboard.refreshing": "Wird aktualisiert…",
  "dashboard.loading": "Dashboard wird geladen…",
  "dashboard.loadFailed": "Das Dashboard konnte nicht geladen werden.",
  "dashboard.alertsAria": "Jetzt zu erledigen",
  "dashboard.alert.open": "Öffnen →",
  "dashboard.alert.critical_report_open.tag": "Kritisch",
  "dashboard.alert.critical_report_open.text": "{count} offene kritische Meldung(en).",
  "dashboard.alert.critical_report_open.review":
    "{count} Person(en) gesperrt bis zur Entscheidung des Teams; erste Prüfung bis {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Prüfung überfällig",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} Sperre(n) haben ihre Prüffrist überschritten (älteste: {date}). Die Personen bleiben gesperrt, bis Sie entscheiden.",
  "dashboard.alert.cases_past_deadline.tag": "Verspätet",
  "dashboard.alert.cases_past_deadline.text":
    "{count} Fall/Fälle haben die Frist für die erste Antwort überschritten ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Angebot",
  "dashboard.alert.thin_coverage.text":
    "{trade} in {city}: {requests} Anfragen heute für {pros} verfügbare(n) Profi(s). Hier muss rekrutiert werden.",
  "dashboard.alert.failed_payments.tag": "Zahlungen",
  "dashboard.alert.failed_payments.text": "{count} fehlgeschlagene Orange-Money-Zahlung(en) heute.",

  "dashboard.card.demand": "Anfragen heute",
  "dashboard.card.demand.answered": "Beantwortet in unter {hours} h",
  "dashboard.card.demand.unanswered": "Unbeantwortet",
  "dashboard.card.demand.expired": "Abgelaufen",
  "dashboard.card.introductions": "Vermittlungen",
  "dashboard.card.introductions.quotes": "Gesendete Angebote",
  "dashboard.card.introductions.median": "Mittlere Zeit bis zur ersten Antwort",
  "dashboard.card.introductions.cancelled": "Vor der Vermittlung storniert",
  "dashboard.card.pros": "Verifizierte Profis",
  "dashboard.card.pros.unit": "aktiv",
  "dashboard.card.pros.new": "Neu in 7 Tagen",
  "dashboard.card.pros.waiting": "Warten auf Verifizierung",
  "dashboard.card.pros.suspended": "Gesperrt",
  "dashboard.card.money": "Eingenommene Gebühren",
  "dashboard.card.money.failed": "Fehlgeschlagene Orange-Money-Zahlungen",
  "dashboard.card.money.approvals": "Offene Genehmigungsanfragen",
  "dashboard.card.money.subscriptions": "Aktive Monatsabos",

  "dashboard.coverage": "Abdeckung nach Gewerk und Gemeinde",
  "dashboard.coverage.empty": "Heute keine Anfragen.",
  "dashboard.coverageFoot":
    "Rot: Weniger als die Hälfte der Anfragen rechtzeitig beantwortet. Hier muss rekrutiert werden.",
  "dashboard.col.trade": "Gewerk",
  "dashboard.col.commune": "Gemeinde",
  "dashboard.col.requests": "Anfragen",
  "dashboard.col.pros": "Verfügbare Profis",
  "dashboard.col.answered": "Beantwortet < {hours} h",

  "dashboard.queues": "Warteschlangen",
  "dashboard.noQueues": "Keine Warteschlangen für Ihre Rollen.",
  "dashboard.queue.late_cases": "Verspätete Fälle",
  "dashboard.queue.open_cases": "Offene Fälle",
  "dashboard.queue.open_cases.meta": "{count} nicht zugewiesen",
  "dashboard.queue.identity_verifications": "Identitätsprüfungen",
  "dashboard.queue.identity_verifications.meta": "die älteste wartet seit {age}",
  "dashboard.queue.safety_reports": "Offene Meldungen",
  "dashboard.queue.severity.critical": "{count} kritisch",
  "dashboard.queue.severity.high": "{count} hoch",
  "dashboard.queue.severity.medium": "{count} mittel",
  "dashboard.queue.severity.low": "{count} niedrig",
  "dashboard.queue.overdue_suspension_reviews": "Überfällige Sperrprüfungen",
  "dashboard.queue.overdue_suspension_reviews.meta": "bleiben gesperrt bis zur Entscheidung",
  "dashboard.queue.payment_approvals": "Genehmigungsanfragen",
};
